import script from "./AnswerTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerTemplates.vue?vue&type=script&setup=true&lang=js"

import "./AnswerTemplates.vue?vue&type=style&index=0&id=34c6bdcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34c6bdcc"]])

export default __exports__